var _ = require('lodash'),
		util = require('./../../../../../app_storefront_core/cartridge/js/util'),
		tls = require('./../../tls');


var $cache = {},
		place,
		placesConfig = {},
		wrongCountryText = Resources.WRONG_COUNTRY,
		addressValidationText = Resources.ADDRESS_VALIDATION,
		noSuggestionsText = Resources.NO_SUGGESTIONS,
		isShippingAddressValidated,
		isAddrSelectedFromBook = false,
		isAddrSelectedFromDropdow = false,
		newestRequestId = 0,
		autocompleteCache = new Map();

var loadScript = _.once(function (url, callback) {
	$.getScript(url, callback);
});

function loadMapsScript(key, callback) {
	if (!key) {
		console.warn('No credentials for load map script.');

		return false;
	}

	return loadScript(util.appendParamsToUrl('//maps.googleapis.com/maps/api/js', {
		key: key,
		libraries: 'places'
	}), callback);
}

function initCache() {
	$cache.address1Input = $('input[name$="_addressFields_address1"]');
	$cache.address2Input = $('input[name$="_addressFields_address2"]');
	$cache.cityInput = $('input[name$="_addressFields_city"]');
	$cache.countrySelect = $('select[id$="_country"]');
	$cache.stateSelect = $('select[name$="_addressFields_states_state"]');
	$cache.postalCodeInput = $('input[name$="_addressFields_postal"]');
	$cache.provinceSelect = $('select[name$="_addressFields_province"]');
	$cache.citySelect = $('select[name$="_addressFields_city"]');
	$cache.districtSelect = $('select[name$="_addressFields_district"]');
	$cache.predictionsList;
	$cache.request = {
		input: '',
		sessionToken: ''
	};
}

function initEvents() {
	watchAddressBook();
}

async function initMapsScript() {
	if (placesConfig.direct_mode) {
		const key = await getCredentials();

		loadMapsScript(key, function() {
			refreshToken();

			if (!$('.js-checkout-edit_billing_block').length || !$('.js-checkout-edit_billing_block').hasClass('hidden')) {
				validateInputAddress();
			}
		});
	}
}

function initPlacesConfig() {
	var selectedCountry = tls.getCookie("selectedCountry");
	var config = JSON.parse(SitePreferences.GOOGLE_PLACES_CONFIG);
	if (config) {
		for (var defaultConfig in config.default) {
			placesConfig[defaultConfig] = config.default[defaultConfig];
		}

		if (selectedCountry in config) {
			for (var countryConfig in config[selectedCountry]) {
				placesConfig[countryConfig] = config[selectedCountry][countryConfig];
			}
		}
	}
}

async function initAutocomplete() {
	if (!$cache.address1Input[0]) {
		return;
	}

	if (!placesConfig.direct_mode) {
		refreshToken();

			if (!$('.js-checkout-edit_billing_block').length || !$('.js-checkout-edit_billing_block').hasClass('hidden')) {
				validateInputAddress();
			}
	}

	createPredictionsContainer();

	$cache.address1Input.on("input", function (e) {
		isAddrSelectedFromDropdow = false;
		makeAutocompleteRequest(e);
		$cache.address1Input.removeClass('error');
		removeCountryError();
	});

	$cache.address1Input.on("blur", function() {
		clearPredictions();

		if (!isAddrSelectedFromDropdow) {
			validateInputAddress();
		}
	});
}

// Watch if a user has selected their address from the book manually
function watchAddressBook(){
	var addrBook = document.querySelector("select[name$='_addressList']");
	if(addrBook) {
		// If selected from the book dropdown manually
		addrBook.addEventListener("click", function (){
			isAddrSelectedFromBook = true;
		});
		addrBook.addEventListener("change", function (e){
			const selectedValue = this.value;
			const selectedOption = this.selectedOptions[0];
			const selectedAddress = selectedOption ? selectedOption.dataset.address : null;

			if (selectedValue && selectedAddress) {
				validateInputAddress(selectedAddress);
			}
		});
		// If an address wasn't selected but
		// the autofilled address matches one of the book's options
		var resultArr = [];
		var addrOptions = addrBook.getElementsByTagName("option");
		var addrFieldVal = document.querySelector('input[name$="_addressFields_address1"]').value;

		Array.from(addrOptions).forEach(function(opt){
			var optionAddr1 = "";
			var val = opt.dataset.address;

			if(val){
				optionAddr1 = JSON.parse(val).address1;
			}

			if(optionAddr1 === addrFieldVal){
				resultArr.push("match");
			}
		});

		if(resultArr.indexOf("match") !== -1) {
			isAddrSelectedFromBook = true;
		}
	}
}

function fillInAddress() {
	var street_number = '';
	var street_name = '';
	var city_name = '';
	var zip_code = '';
	var state_name = '';
	var state_name_short = '';
	var country_name = '';
	var country_name_short = '';
	var postal_town = '';
	var sublocality_level_1 = '';
	if (place.addressComponents) {
		if (place.addressComponents.length > 0) {
			for (var i = 0; i < place.addressComponents.length; i++) {
				var addressType = place.addressComponents[i].types[0];
				switch (addressType) {
					case 'street_number':
						street_number = place.addressComponents[i].longText;
						break;
					case 'premise':
						street_number = street_number ? street_number : place.addressComponents[i].longText;
						break;
					case 'subpremise':
						street_number = street_number ? street_number : place.addressComponents[i].longText;
						break;
					case 'route':
						street_name = place.addressComponents[i].longText;
						break;
					case 'locality':
						city_name = place.addressComponents[i].longText;
						break;
					case 'postal_town':
						postal_town = place.addressComponents[i].longText;
						break;
					case 'sublocality_level_1':
						sublocality_level_1 = place.addressComponents[i].longText;
						street_name = street_name ? street_name : place.addressComponents[i].longText;
						break;
					case 'postal_code':
						zip_code = place.addressComponents[i].longText;
						break;
					case 'administrative_area_level_1':
						state_name = place.addressComponents[i].longText;
						state_name_short = place.addressComponents[i].shortText;
						break;
					case 'country':
						country_name = place.addressComponents[i].longText;
						country_name_short = place.addressComponents[i].shortText;
						break
				}
			}

			if ($cache.countrySelect.val() === country_name_short) {
				if (!!street_name) {
					if (placesConfig.number_first) {
						$cache.address1Input.val((!!street_number ? (street_number + ' ') : '') + street_name);
					} else {
						$cache.address1Input.val(street_name + (!!street_number ? (' ' + street_number) : ''));
					}
				} else {
					$cache.address1Input.val('');
				}

				var formattedCity = cityFormatted(city_name || state_name, postal_town, sublocality_level_1);

				if (!!zip_code) {
					$cache.postalCodeInput.val(zip_code);
					removeErrorAfterSelectSuggestions($cache.postalCodeInput);
				}

				if (!!formattedCity) {
					$cache.cityInput.val(formattedCity);
					removeErrorAfterSelectSuggestions($cache.cityInput);
				}

				if (placesConfig.state_province && !!$cache.stateSelect.length) {
					$cache.stateSelect.val(!!state_name_short ? state_name_short : '');
				} else if (!$cache.stateSelect.is(':disabled')) {
					$('select[name$="_addressFields_states_state"]').val(!!state_name_short ? state_name_short : '')
				}

				if ($cache.countrySelect.val() === 'CN' && placesConfig.state_province) {
					if (!!$cache.provinceSelect.length && !!state_name_short) {
						selectOptionByValuePrefix($cache.provinceSelect, normalizeName(state_name_short));
					}

					if (!!$cache.citySelect.length && !!city_name) {
						selectOptionByValuePrefix($cache.citySelect, normalizeName(city_name));
					}

					if (!!$cache.districtSelect.length && !!sublocality_level_1) {
						selectOptionByValuePrefix($cache.districtSelect, normalizeName(sublocality_level_1));
					}
				}
			} else {
				displayCountryError(wrongCountryText);
			}
		}
	}
}

// Triggered for address forms by app_storefront_core_UI/cartridge/js/pages/checkout/index.js
function checkOnSubmit(){
	var address1InputVal = $cache.address1Input.val();
	if (address1InputVal.length > 0){
		if(!place && placesConfig.enabled && isAddrSelectedFromBook){// if the address was selected from book but not dropdown
			isShippingAddressValidated = true;
		} else if(!place && placesConfig.enabled){// mark non-validated address)
			isShippingAddressValidated = false;
		} else if (place && placesConfig.enabled){// if user has selected a value from the dropdown
			isShippingAddressValidated = true;
		} else if (!placesConfig.enabled){// if the check is off, consider the address always good
			isShippingAddressValidated = isShippingAddressValidated || true;
		}
	// Add cookie for passing isShippingAddressValidated to Order attr
		createAddrStatusCookie(isShippingAddressValidated);
	} // else: the address is empty, and will be handled by another validator
}

function createAddrStatusCookie(status) {
	var cookieName = "isShippingAddressValidated";
	var cookieExpDate = new Date(Date.now() + 3600000).toLocaleString();
	document.cookie = cookieName + "=" + status + ";path=/;expires=" + cookieExpDate;
}

function displayCountryError(text) {
	const existingEl = $('#country-error-message');

	let className = 'error';

	if (text === wrongCountryText) {
		place = null;
		$cache.address1Input.val('');
	} else {
		className += ' warning';
	}

	if (existingEl.length > 0) {
		if (existingEl.text() !== text) {
			existingEl.text(text);
		}

		existingEl.attr('class', className);
	} else {
		const errorEl = $('<p>', {
			id: 'country-error-message',
			class: className,
			text
		});
		$cache.address1Input.parent().append(errorEl);
	}
}

function removeCountryError() {
	if ($('#country-error-message').length) {
		$('#country-error-message').remove();
	}
}

function cityFormatted(param_city, param_postalTown, param_sublocality_level_1) {
	var selectedCountry = $cache.countrySelect.val();
	var arrayNation = ["SE", "GB"];

	if (!!selectedCountry) {
		if (arrayNation.indexOf(selectedCountry) >= 0)
			return param_postalTown;
		else {
			if (selectedCountry == "US") {
				return !!param_sublocality_level_1 ? param_sublocality_level_1 : param_city;
			}
			return param_city;
		}
	}

	return param_city;
}

function normalizeName(str) {
	if (!str) return '';

	const cleaned = str
		.toLowerCase()
		.replace(/\s+/g, '')
		.replace(/sheng|shi|qu|xian|zu|zi|zhi|city|district|county/g, '')
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, '');

	return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
}

function selectOptionByValuePrefix(selectEl, valuePrefix) {
	selectEl.find('option').each(function () {
		if ($(this).val().startsWith(valuePrefix)) {
			$(this).prop('selected', true);
			selectEl.trigger('change');

			return false;
		}
	});
}

// Google Places API (new)
function createPredictionsContainer() {
	const anchor = document.createElement('div');
	anchor.className = 'predictions-anchor';

	const dropdown = document.createElement('div');
	dropdown.className = 'dropdown';

	const ul = document.createElement('ul');
	const logo = document.createElement('div');
	logo.className = 'powered-by-google';

	anchor.append(dropdown);
	dropdown.append(ul);
	dropdown.append(logo);

	$cache.predictionsList = $(ul);

	if ($cache.address1Input[0]) {
		$(anchor).insertAfter($cache.address1Input[0]);
	}

	document.addEventListener('pointerdown', (e) => {
		const target = e.target;

		const isOutsideAnchor = !anchor.contains(target);
		const isOutsideInput = !$cache.address1Input[0] || !$cache.address1Input[0].contains(target);

		if (isOutsideAnchor && isOutsideInput) {
			$cache.predictionsList.empty();
		}
	});
}

function refreshToken() {
	$cache.request.sessionToken = placesConfig.direct_mode ? new google.maps.places.AutocompleteSessionToken() : crypto.randomUUID();
}

var makeAutocompleteRequest = _.debounce(async function (inputEvent) {
	const inputValue = inputEvent.target.value.trim();
	const charNumbers = placesConfig.charNumbers || 3;

	if (!inputValue || inputValue.length < charNumbers) {
		clearPredictions();
		return;
	}

	const cached = autocompleteCache.get(inputValue.toLowerCase());

	if (cached) {
		renderPredictions(cached);
		return;
	}

	$cache.request.input = inputValue;

	const requestId = ++newestRequestId;

	try {
		const { suggestions } = await getSuggestions();

		if (requestId !== newestRequestId) return;

		autocompleteCache.set(inputValue.toLowerCase(), suggestions);

		renderPredictions(suggestions);
	} catch (error) {
		console.error('Autocomplete fetch error:', error);
	}
}, placesConfig.debounce || 300);

async function getSuggestions() {
	const fallbackResult = { suggestions: [] };
	const selectedCountry = $cache.countrySelect.val() || "";

	try {
		if (placesConfig.direct_mode) {
			const language = tls.getCookie("preferredLocale") || "en";

			$cache.request.includedPrimaryTypes = placesConfig.includedPrimaryTypes || [];
			$cache.request.includedRegionCodes = selectedCountry ? [selectedCountry] : [];
			$cache.request.region = selectedCountry;
			$cache.request.language = language;

			return await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions($cache.request);
		}

		$cache.request.selectedCountry = selectedCountry;

		const response = await fetch(Urls.autocompletePlaces, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify($cache.request)
		});

		if (!response.ok) {
			console.error(`Autocomplete failed: ${response.status}`);

			return fallbackResult;
		}

		const result = await response.json();

		if (!result || typeof result !== 'object' || !Array.isArray(result.suggestions)) {
			console.warn('Unexpected autocomplete response format:', result);

			return fallbackResult;
		}

		return result;
	} catch (error) {
		console.error('Get suggestions error: ', error);

		return fallbackResult;
	}
}

async function onPlaceSelected(placePrediction) {
	try {
		if (placesConfig.direct_mode) {
			const { place } = await placePrediction.toPlace().fetchFields({
				fields: ['addressComponents']
			});

			return place || null;
		}

		const response = await fetch(Urls.getPlace, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ placeId: placePrediction.placeId, sessionToken: $cache.request.sessionToken, selectedCountry: $cache.countrySelect.val()})
		});

		if (!response.ok) {
			console.error(`Get place failed: ${response.status}`);
			clearPredictions();

			return null;
		}

		const { place } = await response.json();

		return place || null;
	} catch (error) {
		console.error('Get place error:', error);
		return null;
	}
}

function renderPredictions(suggestions) {
	clearPredictions();

	if (suggestions.length === 0) {
		const li = document.createElement('li');
		const span = document.createElement('span');
		span.className = 'not-found';

		span.textContent = noSuggestionsText;

		span.addEventListener('pointerdown', () => clearPredictions);

		li.append(span);
		$cache.predictionsList.append(li);

		return false;
	}

	for (const suggestion of suggestions) {
		const placePrediction = suggestion.placePrediction;
		const li = document.createElement('li');
		const span = document.createElement('span');

		span.textContent = placePrediction.text.text.toString();

		span.addEventListener('pointerdown', async () => {
			isAddrSelectedFromDropdow = true;

			place = await onPlaceSelected(placePrediction);

			refreshToken();
			fillInAddress();
			clearPredictions();
		});

		li.append(span);
		$cache.predictionsList.append(li);
	}
}

function clearPredictions() {
	if ($cache.predictionsList) {
		$cache.predictionsList.empty();
	}
}

async function getCredentials() {
	try {
		const response = await fetch(Urls.getCredentials, {
			method: 'POST'
		});

		if (!response.ok) {
			console.error(`Get credentials failed: ${response.status}`);
			return;
		}

		const { key } = await response.json();

		return key;
	} catch (error) {
		console.error('Get credentials error:', error);
		return null;
	}

}

async function validateInputAddress(selectedAddress) {
	if (!$cache.address1Input.val() || !placesConfig.strict_mode) {
		return false;
	}

	$cache.request.input = $cache.address1Input.val();

	try {
		if (selectedAddress) {
			const countryCode = JSON.parse(selectedAddress).countryCode;

			if ($cache.countrySelect.val() !== countryCode) {
				$cache.cityInput.val('');
				$cache.postalCodeInput.val('');
				displayCountryError(wrongCountryText);

				return false;
			}
		}

		const { suggestions } = await getSuggestions();

		if (!suggestions || !suggestions.length) {
			displayCountryError(addressValidationText);
		} else {
			removeCountryError();
		}
	} catch (error) {
		console.error('Validate address fetch error:', error);
	}
}

function removeErrorAfterSelectSuggestions($input) {
	if ($input.val()) {
		$input.removeClass('error');

		const labelError = $input.parent().find('label.error');

		if (labelError.length) {
			labelError.empty();
			labelError.hide();
		}
	}
}

exports.placesConfig = placesConfig;
exports.checkOnSubmit = checkOnSubmit;

exports.init = function () {
	initPlacesConfig();
	if (placesConfig.enabled) {
		initCache();
		initMapsScript();
		initEvents();
		initAutocomplete();
	}
};
